import React from 'react';
import './ProductSection.css';

const ProductSection = () => {
  const products = [
    {
      title: 'Architectural Lighting',
      features: ['Detailed specifications', 'Secure payments'],
      image: 'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?w=400&h=240&fit=crop'
    },
    {
      title: 'Premium Finishes',
      features: ['Easy order tracking', 'Bulk sourcing'],
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=240&fit=crop'
    },
    {
      title: 'Smart Fixtures',
      features: ['Verified quality', 'Express delivery'],
      image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=240&fit=crop'
    },
    {
      title: 'Bespoke Furniture',
      features: ['Custom designs', 'Global shipping'],
      image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=240&fit=crop'
    }
  ];

  return (
    <section className="product-section" id="products">
      <div className="container product-section-container">
        <div className="product-section-header">
          <h2 className="product-section-title">
            Premium Interior Products, <span className="product-section-title-accent">Direct from Us</span>
          </h2>
          <a href="#products" className="product-view-more">View More</a>
        </div>
        <p className="product-section-description">
          Access a curated catalog of high-end materials and furniture with manufacturer-direct pricing and guaranteed quality.
        </p>
        <div className="product-grid">
          {products.map((product, index) => (
            <div key={index} className="product-card">
              <div className="product-card-image-wrap">
                <img src={product.image} alt={product.title} className="product-card-image" />
              </div>
              <h3 className="product-title">{product.title}</h3>
              <ul className="product-features">
                {product.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <button type="button" className="product-btn">Shop Now</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
